import TextInput from "@/components/textfields";
import { Box, styled, Typography } from "@mui/material";
import { tokens } from "@/tokens";

export const StyledTextInput = styled(TextInput)({
  marginBottom: "16px",
});

export const StyledBox = styled(Box)({
  padding: "8px 16px",
});

export const HeadingText = styled(Typography)({
  fontWeight: tokens.fontWeight.semibold,
  fontSize: tokens.fontSize.xl,
});
